export const renderValue = (value: string) => <>{value}</>;
